import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { Grid, Table, TableHead, TableBody, TableRow, TableCell, Box } from '@mui/material';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import { DetatchedAccordion, BoxActionsWrapper } from 'components/common/CommonStyles';

const OfferAssetPropertiesHistoryModal = React.memo(({ closeModal, loadPropertiesHistory, assetId }) => {
  const [propertiesHistory, setPropertiesHistory] = useState([]);

  const getPropertiesHistory = useCallback(() => {
    loadPropertiesHistory(assetId).then(options => {
      setPropertiesHistory([...options]);
    });
  }, [assetId, loadPropertiesHistory]);

  useEffect(() => {
    getPropertiesHistory();
  }, [getPropertiesHistory]);

  const [t] = useTranslation();

  return (
    <Dialog
      open={true}
      aria-labelledby='partnerManualInterrogation-dialog-title'
      maxWidth='lg'
      fullWidth
      disableEscapeKeyDown
      onClose={closeModal}
      content={
        <Grid container direction={'column'}>
          {propertiesHistory && propertiesHistory.length > 0 ? (
            propertiesHistory.map((prop, idx) => (
              <div key={prop.logId}>
                <DetatchedAccordion
                  defaultExpanded={false}
                  title={
                    <Grid item xs={12} sm={12} md={12}>
                      <span id={'OfferAssetPropertiesHistory_header_' + idx}>
                        {prop.userName} - {t('DATE_TIME', { date: prop.changeDate })} - {prop.reason}
                      </span>
                    </Grid>
                  }
                  content={
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{t('OfferEdit.Asset.Properties.PropertyName')}</TableCell>
                          <TableCell>{t('OfferEdit.Asset.Properties.OldPropertyValue')}</TableCell>
                          <TableCell>{t('OfferEdit.Asset.Properties.NewPropertyValue')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {prop.details.map(detail => {
                          return (
                            <TableRow key={detail.logDetailId}>
                              <TableCell>{detail.propertyName}</TableCell>
                              <TableCell>{detail.oldPropertyValue}</TableCell>
                              <TableCell>{detail.newPropertyValue}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  }
                />
              </div>
            ))
          ) : (
            <Box p={1}>{t('ResultsNotFound')}</Box>
          )}
        </Grid>
      }
      actions={
        <BoxActionsWrapper forDialog>
          <Button id={'offerAssetProperties_propertiesHistoryModal_closeBtn'} color='primary' variant='contained' onClick={closeModal}>
            {t('Close')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
});

OfferAssetPropertiesHistoryModal.displayName = 'OfferAssetPropertiesHistoryModal';

OfferAssetPropertiesHistoryModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  loadPropertiesHistory: PropTypes.func.isRequired,
  assetId: PropTypes.number.isRequired
};

export default compose(withTranslation())(OfferAssetPropertiesHistoryModal);
